var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "loading-dots_svg__loading",
    viewBox: "0 0 132 58",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 30,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 30,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 30,
    r: 13
  }))));
}
export default SvgLoadingDots;